import {
  TransactionControlTypeEnum,
  type TransactionControlTypeEnum as TransactionControlTypeEnumType,
} from '@talos/kyoko';

const TRANSACTION_CONTROL_TYPE_TEXT_MAPPING: Record<TransactionControlTypeEnumType, string> = {
  [TransactionControlTypeEnum.All]: 'All',
  [TransactionControlTypeEnum.AllFees]: 'All Fees',
  [TransactionControlTypeEnum.AllTransferFees]: 'All Transfer Fees',
  [TransactionControlTypeEnum.CashMarginPayment]: 'Cash Margin Payment',
  [TransactionControlTypeEnum.CollateralPost]: 'Collateral Post',
  [TransactionControlTypeEnum.CollateralRelease]: 'Collateral Release',
  [TransactionControlTypeEnum.CollateralSubstitutionIn]: 'Collateral Substitution In',
  [TransactionControlTypeEnum.CollateralSubstitutionOut]: 'Collateral Substitution Out',
  [TransactionControlTypeEnum.CollateralTopUp]: 'Collateral Top Up',
  [TransactionControlTypeEnum.CollateralWithdrawal]: 'Collateral Withdrawal',
  [TransactionControlTypeEnum.Delivery]: 'Delivery',
  [TransactionControlTypeEnum.DeliveryFee]: 'Delivery Fee',
  [TransactionControlTypeEnum.Deposit]: 'Deposit',
  [TransactionControlTypeEnum.DepositFee]: 'Deposit Fee',
  [TransactionControlTypeEnum.DepositInterest]: 'Deposit Interest',
  [TransactionControlTypeEnum.FinalCreate]: 'Final Create',
  [TransactionControlTypeEnum.FinalRedeem]: 'Final Redeem',
  [TransactionControlTypeEnum.FundingPnL]: 'Funding PnL',
  [TransactionControlTypeEnum.LateFee]: 'Late Fee',
  [TransactionControlTypeEnum.Liquidation]: 'Liquidation',
  [TransactionControlTypeEnum.LiquidationFee]: 'Liquidation Fee',
  [TransactionControlTypeEnum.LiquidationProceeds]: 'Liquidation Proceeds',
  [TransactionControlTypeEnum.LoanInterest]: 'Loan Interest',
  [TransactionControlTypeEnum.LoanPrincipal]: 'Loan Principal',
  [TransactionControlTypeEnum.LoanPrincipalRepayment]: 'Loan Principal Repayment',
  [TransactionControlTypeEnum.ManagementFee]: 'Management Fee',
  [TransactionControlTypeEnum.ManufacturedPayment]: 'Manufactured Payment',
  [TransactionControlTypeEnum.Misc]: 'Misc',
  [TransactionControlTypeEnum.MiscFee]: 'Misc Fee',
  [TransactionControlTypeEnum.OriginationFee]: 'Origination Fee',
  [TransactionControlTypeEnum.PreliminaryCreate]: 'Preliminary Create',
  [TransactionControlTypeEnum.PreliminaryRedeem]: 'Preliminary Redeem',
  [TransactionControlTypeEnum.PrepaymentFee]: 'Prepayment Fee',
  [TransactionControlTypeEnum.RealizedPnL]: 'Realized PnL',
  [TransactionControlTypeEnum.ReconAdjustment]: 'Recon Adjustment',
  [TransactionControlTypeEnum.Settlement]: 'Settlement',
  [TransactionControlTypeEnum.SettlementFee]: 'Settlement Fee',
  [TransactionControlTypeEnum.StakingReward]: 'Staking Reward',
  [TransactionControlTypeEnum.StakingRewardFee]: 'Staking Reward Fee',
  [TransactionControlTypeEnum.TradingFee]: 'Trading Fee',
  [TransactionControlTypeEnum.TransferFee]: 'Transfer Fee',
  [TransactionControlTypeEnum.Withdrawal]: 'Withdrawal',
  [TransactionControlTypeEnum.WithdrawalFee]: 'Withdrawal Fee',
  [TransactionControlTypeEnum.Trade]: 'Trade',
  [TransactionControlTypeEnum.ExternalReconAdjustment]: 'External Recon Adjustment',
  [TransactionControlTypeEnum.InKindCreate]: 'In Kind Create',
  [TransactionControlTypeEnum.InKindRedeem]: 'In Kind Redeem',
};

export function prettifyTransactionControlTypeEnum(type: TransactionControlTypeEnumType | string): string {
  return TRANSACTION_CONTROL_TYPE_TEXT_MAPPING[type as TransactionControlTypeEnumType] ?? type;
}
